import type { ReactNode } from 'react'
import { useAuth } from './AuthProvider'
import { SignIn } from './SignIn'

/**
 * Gate for every authenticated route.
 *
 * Renders nothing while Firebase resolves the persisted session — a brief
 * blank beats flashing the sign-in screen at an already-signed-in user on
 * every page load.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useAuth()

  if (state.status === 'loading') {
    return (
      <div
        className="flex min-h-dvh items-center justify-center"
        role="status"
        aria-live="polite"
      >
        <span className="sr-only">Loading</span>
      </div>
    )
  }

  if (state.status !== 'signed-in') {
    return <SignIn />
  }

  return <>{children}</>
}
